export default __webpack_public_path__ + "static/media/blue-detail.dca390af.svg";